import {
  Box,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  styled
} from '@mui/material';

interface LogoProps {
  collapsed?: boolean;
}

interface LogoWrapperProps {
  collapsed?: boolean;
}

const LogoWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed'
})<LogoWrapperProps>(
  ({ collapsed }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${collapsed ? '40px' : '100%'};
    height: ${collapsed ? '40px' : 'auto'};
    overflow: hidden;
    transition: all 0.3s ease;
`
);

interface LogoImageProps {
  collapsed?: boolean;
}

const LogoImage = styled('img', {
  shouldForwardProp: (prop) => prop !== 'collapsed'
})<LogoImageProps>(
  ({ collapsed }) => `
    height: ${collapsed ? '28px' : '32px'};
    width: auto;
    max-width: 100%;
    object-fit: contain;
    transition: all 0.3s ease;
`
);

const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

function Logo({ collapsed = false }: LogoProps) {
  return (
    <LogoWrapper collapsed={collapsed}>
      <TooltipWrapper
        title="24F Dashboard"
        arrow
        placement="right"
      >
        <LogoImage
          collapsed={collapsed}
          src="/static/images/logo/24f-logo.png"
          alt="24F Logo"
        />
      </TooltipWrapper>
    </LogoWrapper>
  );
}

export default Logo;
